// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! sanitize.css v4.1.0 | CC0 License | github.com/jonathantneal/sanitize.css */

/* Display definitions
   ========================================================================== */

/**
 * Add the correct display in IE 9-.
 * 1. Add the correct display in Edge, IE, and Firefox.
 * 2. Add the correct display in IE.
 */

 article,
 aside,
 details, /* 1 */
 figcaption,
 figure,
 footer,
 header,
 main, /* 2 */
 menu,
 nav,
 section,
 summary { /* 1 */
     display: block;
 }
 
 /**
  * Add the correct display in IE 9-.
  */
 
 audio,
 canvas,
 progress,
 video {
     display: inline-block;
 }
 
 /**
  * Add the correct display in iOS 4-7.
  */
 
 audio:not([controls]) {
     display: none;
     height: 0;
 }
 
 /**
  * Add the correct display in IE 10-.
  * 1. Add the correct display in IE.
  */
 
 template, /* 1 */
 [hidden] {
     display: none;
 }
 
 /* Elements of HTML (https://www.w3.org/TR/html5/semantics.html)
    ========================================================================== */
 
 /**
  * 1. Remove repeating backgrounds in all browsers (opinionated).
  * 2. Add box sizing inheritence in all browsers (opinionated).
  */
 
 *,
 ::before,
 ::after {
     background-repeat: no-repeat; /* 1 */
     box-sizing: inherit; /* 2 */
 }
 
 /**
  * 1. Add text decoration inheritance in all browsers (opinionated).
  * 2. Add vertical alignment inheritence in all browsers (opinionated).
  */
 
 ::before,
 ::after {
     text-decoration: inherit; /* 1 */
     vertical-align: inherit; /* 2 */
 }
 
 /**
  * 1. Add border box sizing in all browsers (opinionated).
  * 2. Add the default cursor in all browsers (opinionated).
  * 3. Add a flattened line height in all browsers (opinionated).
  * 4. Prevent font size adjustments after orientation changes in IE and iOS.
  */
 
 html {
     box-sizing: border-box; /* 1 */
     cursor: default; /* 2 */
     font-family: sans-serif; /* 3 */
     line-height: 1.5; /* 3 */
     -ms-text-size-adjust: 100%; /* 4 */
     -webkit-text-size-adjust: 100%; /* 5 */
 }
 
 /* Sections (https://www.w3.org/TR/html5/sections.html)
    ========================================================================== */
 
 /**
  * Remove the margin in all browsers (opinionated).
  */
 
 body {
     margin: 0;
 }
 
 /**
  * Correct the font sizes and margins on \`h1\` elements within
  * \`section\` and \`article\` contexts in Chrome, Firefox, and Safari.
  */
 
 h1 {
     font-size: 2em;
     margin: .67em 0;
 }
 
 /* Grouping content (https://www.w3.org/TR/html5/grouping-content.html)
    ========================================================================== */
 
 /**
  * 1. Correct font sizing inheritance and scaling in all browsers.
  * 2. Correct the odd \`em\` font sizing in all browsers.
  */
 
 code,
 kbd,
 pre,
 samp {
     font-family: monospace, monospace; /* 1 */
     font-size: 1em; /* 2 */
 }
 
 /**
  * 1. Correct the height in Firefox.
  * 2. Add visible overflow in Edge and IE.
  */
 
 hr {
     height: 0; /* 1 */
     overflow: visible; /* 2 */
 }
 
 /**
  * Remove the list style on navigation lists in all browsers (opinionated).
  */
 
 nav ol,
 nav ul {
     list-style: none;
 }
 
 /* Text-level semantics
    ========================================================================== */
 
 /**
  * 1. Add a bordered underline effect in all browsers.
  * 2. Remove text decoration in Firefox 40+.
  */
 
 abbr[title] {
     border-bottom: 1px dotted; /* 1 */
     text-decoration: none; /* 2 */
 }
 
 /**
  * Prevent the duplicate application of \`bolder\` by the next rule in Safari 6.
  */
 
 b,
 strong {
     font-weight: inherit;
 }
 
 /**
  * Add the correct font weight in Chrome, Edge, and Safari.
  */
 
 b,
 strong {
     font-weight: bolder;
 }
 
 /**
  * Add the correct font style in Android 4.3-.
  */
 
 dfn {
     font-style: italic;
 }
 
 /**
  * Add the correct colors in IE 9-.
  */
 
 mark {
     background-color: #ffff00;
     color: #000000;
 }
 
 /**
  * Add the correct vertical alignment in Chrome, Firefox, and Opera.
  */
 
 progress {
     vertical-align: baseline;
 }
 
 /**
  * Correct the font size in all browsers.
  */
 
 small {
     font-size: 83.3333%;
 }
 
 /**
  * Change the positioning on superscript and subscript elements
  * in all browsers (opinionated).
  * 1. Correct the font size in all browsers.
  */
 
 sub,
 sup {
     font-size: 83.3333%; /* 1 */
     line-height: 0;
     position: relative;
     vertical-align: baseline;
 }
 
 sub {
     bottom: -.25em;
 }
 
 sup {
     top: -.5em;
 }
 
 /*
  * Remove the text shadow on text selections (opinionated).
  * 1. Restore the coloring undone by defining the text shadow (opinionated).
  */
 
 ::-moz-selection {
     background-color: #b3d4fc; /* 1 */
     color: #000000; /* 1 */
     text-shadow: none;
 }
 
 ::selection {
     background-color: #b3d4fc; /* 1 */
     color: #000000; /* 1 */
     text-shadow: none;
 }
 
 /* Embedded content (https://www.w3.org/TR/html5/embedded-content-0.html)
    ========================================================================== */
 
 /*
  * Change the alignment on media elements in all browers (opinionated).
  */
 
 audio,
 canvas,
 iframe,
 img,
 svg:not([class^="Mui"]),
 video {
     vertical-align: middle;
 }
 
 /**
  * Remove the border on images inside links in IE 10-.
  */
 
 img {
     border-style: none;
 }
 
 /**
  * Change the fill color to match the text color in all browsers (opinionated).
  */
 
 svg {
     fill: currentColor;
 }
 
 /**
  * Hide the overflow in IE.
  */
 
 svg:not(:root) {
     overflow: hidden;
 }
 
 /* Links (https://www.w3.org/TR/html5/links.html#links)
    ========================================================================== */
 
 /**
  * 1. Remove the gray background on active links in IE 10.
  * 2. Remove the gaps in underlines in iOS 8+ and Safari 8+.
  */
 
 a {
     background-color: transparent; /* 1 */
     -webkit-text-decoration-skip: objects; /* 2 */
 }
 
 /**
  * Remove the outline when hovering in all browsers (opinionated).
  */
 
 a:hover {
     outline-width: 0;
 }
 
 /* Tabular data (https://www.w3.org/TR/html5/tabular-data.html)
    ========================================================================== */
 
 /*
  * Remove border spacing in all browsers (opinionated).
  */
 
 table {
     border-collapse: collapse;
     border-spacing: 0;
 }
 
 /* transform-style:  (https://www.w3.org/TR/html5/forms.html)
    ========================================================================== */
 
 /**
  * 1. Remove the default styling in all browsers (opinionated).
  * 3. Remove the margin in Firefox and Safari.
  */
 
 button,
 input,
 select,
 textarea {
     background-color: transparent; /* 1 */
     border-style: none; /* 1 */
     color: inherit; /* 1 */
     font-size: 1em; /* 1 */
     margin: 0; /* 3 */
 }
 
 /**
  * Correct the overflow in IE.
  * 1. Correct the overflow in Edge.
  */
 
 button,
 input { /* 1 */
     overflow: visible;
 }
 
 /**
  * Remove the inheritance in Edge, Firefox, and IE.
  * 1. Remove the inheritance in Firefox.
  */
 
 button,
 select { /* 1 */
     text-transform: none;
 }
 
 /**
  * 1. Prevent the WebKit bug where (2) destroys native \`audio\` and \`video\`
  *    controls in Android 4.
  * 2. Correct the inability to style clickable types in iOS and Safari.
  */
 
 button,
 html [type="button"], /* 1 */
 [type="reset"],
 [type="submit"] {
     -webkit-appearance: button; /* 2 */
 }
 
 /**
  * Remove the inner border and padding in Firefox.
  */
 
 ::-moz-focus-inner {
     border-style: none;
     padding: 0;
 }
 
 /**
  * Correct the focus styles unset by the previous rule.
  */
 
 :-moz-focusring {
     outline: 1px dotted ButtonText;
 }
 
 /**
  * Correct the border, margin, and padding in all browsers.
  */
 
 fieldset {
     border: 1px solid #c0c0c0;
     margin: 0 2px;
     padding: .35em .625em .75em;
 }
 
 /**
  * 1. Correct the text wrapping in Edge and IE.
  * 2. Remove the padding so developers are not caught out when they zero out
  *    \`fieldset\` elements in all browsers.
  */
 
 legend {
     display: table; /* 1 */
     max-width: 100%; /* 1 */
     padding: 0; /* 2 */
     white-space: normal; /* 1 */
 }
 
 /**
  * 1. Remove the vertical scrollbar in IE.
  * 2. Change the resize direction on textareas in all browsers (opinionated).
  */
 
 textarea {
     overflow: auto; /* 1 */
     resize: vertical; /* 2 */
 }
 
 /**
  * Remove the padding in IE 10-.
  */
 
 [type="checkbox"],
 [type="radio"] {
     padding: 0;
 }
 
 /**
  * Correct the cursor style on increment and decrement buttons in Chrome.
  */
 
 ::-webkit-inner-spin-button,
 ::-webkit-outer-spin-button {
     height: auto;
 }
 
 /**
  * 1. Correct the odd appearance in Chrome and Safari.
  * 2. Correct the outline style in Safari.
  */
 
 [type="search"] {
     -webkit-appearance: textfield; /* 1 */
     outline-offset: -2px; /* 2 */
 }
 
 /**
  * Remove the inner padding and cancel buttons in Chrome and Safari for OS X.
  */
 
 ::-webkit-search-cancel-button,
 ::-webkit-search-decoration {
     -webkit-appearance: none;
 }
 
 /**
  * Correct the text style on placeholders in Chrome, Edge, and Safari.
  */
 
 ::-webkit-input-placeholder {
     color: inherit;
     opacity: .54;
 }
 
 /**
  * 1. Correct the inability to style clickable types in iOS and Safari.
  * 2. Change font properties to \`inherit\` in Safari.
  */
 
 ::-webkit-file-upload-button {
     -webkit-appearance: button; /* 1 */
     font: inherit; /* 2 */
 }
 
 /* WAI-ARIA (https://www.w3.org/TR/html5/dom.html#wai-aria)
    ========================================================================== */
 
 /**
  * Change the cursor on busy elements (opinionated).
  */
 
 [aria-busy="true"] {
     cursor: progress;
 }
 
 /*
  * Change the cursor on control elements (opinionated).
  */
 
 [aria-controls] {
     cursor: pointer;
 }
 
 /*
  * Change the cursor on disabled, not-editable, or otherwise
  * inoperable elements (opinionated).
  */
 
 [aria-disabled] {
     cursor: default;
 }
 
 /* User interaction (https://www.w3.org/TR/html5/editing.html)
    ========================================================================== */
 
 /*
  * Remove the tapping delay on clickable elements (opinionated).
  * 1. Remove the tapping delay in IE 10.
  */
 
 a,
 area,
 button,
 input,
 label,
 select,
 textarea,
 [tabindex] {
     -ms-touch-action: manipulation; /* 1 */
     touch-action: manipulation;
 }
 
 /*
  * Change the display on visually hidden accessible elements (opinionated).
  */
 
 [hidden][aria-hidden="false"] {
     clip: rect(0, 0, 0, 0);
     display: inherit;
     position: absolute;
 }
 
 [hidden][aria-hidden="false"]:focus {
     clip: auto;
 }
 
 p {
    font-family: unset;
 }`, "",{"version":3,"sources":["webpack://./app/styles/sanitize.css"],"names":[],"mappings":"AAAA,+EAA+E;;AAE/E;+EAC+E;;AAE/E;;;;EAIE;;CAED;;;;;;;;;;;WAWU,MAAM;KACZ,cAAc;CAClB;;CAEA;;GAEE;;CAEF;;;;KAII,qBAAqB;CACzB;;CAEA;;GAEE;;CAEF;KACI,aAAa;KACb,SAAS;CACb;;CAEA;;;GAGE;;CAEF;;KAEI,aAAa;CACjB;;CAEA;gFAC+E;;CAE/E;;;GAGE;;CAEF;;;KAGI,4BAA4B,EAAE,MAAM;KACpC,mBAAmB,EAAE,MAAM;CAC/B;;CAEA;;;GAGE;;CAEF;;KAEI,wBAAwB,EAAE,MAAM;KAChC,uBAAuB,EAAE,MAAM;CACnC;;CAEA;;;;;GAKE;;CAEF;KACI,sBAAsB,EAAE,MAAM;KAC9B,eAAe,EAAE,MAAM;KACvB,uBAAuB,EAAE,MAAM;KAC/B,gBAAgB,EAAE,MAAM;KACxB,0BAA0B,EAAE,MAAM;KAClC,8BAA8B,EAAE,MAAM;CAC1C;;CAEA;gFAC+E;;CAE/E;;GAEE;;CAEF;KACI,SAAS;CACb;;CAEA;;;GAGE;;CAEF;KACI,cAAc;KACd,eAAe;CACnB;;CAEA;gFAC+E;;CAE/E;;;GAGE;;CAEF;;;;KAII,iCAAiC,EAAE,MAAM;KACzC,cAAc,EAAE,MAAM;CAC1B;;CAEA;;;GAGE;;CAEF;KACI,SAAS,EAAE,MAAM;KACjB,iBAAiB,EAAE,MAAM;CAC7B;;CAEA;;GAEE;;CAEF;;KAEI,gBAAgB;CACpB;;CAEA;gFAC+E;;CAE/E;;;GAGE;;CAEF;KACI,yBAAyB,EAAE,MAAM;KACjC,qBAAqB,EAAE,MAAM;CACjC;;CAEA;;GAEE;;CAEF;;KAEI,oBAAoB;CACxB;;CAEA;;GAEE;;CAEF;;KAEI,mBAAmB;CACvB;;CAEA;;GAEE;;CAEF;KACI,kBAAkB;CACtB;;CAEA;;GAEE;;CAEF;KACI,yBAAyB;KACzB,cAAc;CAClB;;CAEA;;GAEE;;CAEF;KACI,wBAAwB;CAC5B;;CAEA;;GAEE;;CAEF;KACI,mBAAmB;CACvB;;CAEA;;;;GAIE;;CAEF;;KAEI,mBAAmB,EAAE,MAAM;KAC3B,cAAc;KACd,kBAAkB;KAClB,wBAAwB;CAC5B;;CAEA;KACI,cAAc;CAClB;;CAEA;KACI,UAAU;CACd;;CAEA;;;GAGE;;CAEF;KACI,yBAAyB,EAAE,MAAM;KACjC,cAAc,EAAE,MAAM;KACtB,iBAAiB;CACrB;;CAEA;KACI,yBAAyB,EAAE,MAAM;KACjC,cAAc,EAAE,MAAM;KACtB,iBAAiB;CACrB;;CAEA;gFAC+E;;CAE/E;;GAEE;;CAEF;;;;;;KAMI,sBAAsB;CAC1B;;CAEA;;GAEE;;CAEF;KACI,kBAAkB;CACtB;;CAEA;;GAEE;;CAEF;KACI,kBAAkB;CACtB;;CAEA;;GAEE;;CAEF;KACI,gBAAgB;CACpB;;CAEA;gFAC+E;;CAE/E;;;GAGE;;CAEF;KACI,6BAA6B,EAAE,MAAM;KACrC,qCAAqC,EAAE,MAAM;CACjD;;CAEA;;GAEE;;CAEF;KACI,gBAAgB;CACpB;;CAEA;gFAC+E;;CAE/E;;GAEE;;CAEF;KACI,yBAAyB;KACzB,iBAAiB;CACrB;;CAEA;gFAC+E;;CAE/E;;;GAGE;;CAEF;;;;KAII,6BAA6B,EAAE,MAAM;KACrC,kBAAkB,EAAE,MAAM;KAC1B,cAAc,EAAE,MAAM;KACtB,cAAc,EAAE,MAAM;KACtB,SAAS,EAAE,MAAM;CACrB;;CAEA;;;GAGE;;CAEF;SACQ,MAAM;KACV,iBAAiB;CACrB;;CAEA;;;GAGE;;CAEF;UACS,MAAM;KACX,oBAAoB;CACxB;;CAEA;;;;GAIE;;CAEF;;;;KAII,0BAA0B,EAAE,MAAM;CACtC;;CAEA;;GAEE;;CAEF;KACI,kBAAkB;KAClB,UAAU;CACd;;CAEA;;GAEE;;CAEF;KACI,8BAA8B;CAClC;;CAEA;;GAEE;;CAEF;KACI,yBAAyB;KACzB,aAAa;KACb,2BAA2B;CAC/B;;CAEA;;;;GAIE;;CAEF;KACI,cAAc,EAAE,MAAM;KACtB,eAAe,EAAE,MAAM;KACvB,UAAU,EAAE,MAAM;KAClB,mBAAmB,EAAE,MAAM;CAC/B;;CAEA;;;GAGE;;CAEF;KACI,cAAc,EAAE,MAAM;KACtB,gBAAgB,EAAE,MAAM;CAC5B;;CAEA;;GAEE;;CAEF;;KAEI,UAAU;CACd;;CAEA;;GAEE;;CAEF;;KAEI,YAAY;CAChB;;CAEA;;;GAGE;;CAEF;KACI,6BAA6B,EAAE,MAAM;KACrC,oBAAoB,EAAE,MAAM;CAChC;;CAEA;;GAEE;;CAEF;;KAEI,wBAAwB;CAC5B;;CAEA;;GAEE;;CAEF;KACI,cAAc;KACd,YAAY;CAChB;;CAEA;;;GAGE;;CAEF;KACI,0BAA0B,EAAE,MAAM;KAClC,aAAa,EAAE,MAAM;CACzB;;CAEA;gFAC+E;;CAE/E;;GAEE;;CAEF;KACI,gBAAgB;CACpB;;CAEA;;GAEE;;CAEF;KACI,eAAe;CACnB;;CAEA;;;GAGE;;CAEF;KACI,eAAe;CACnB;;CAEA;gFAC+E;;CAE/E;;;GAGE;;CAEF;;;;;;;;KAQI,8BAA8B,EAAE,MAAM;KACtC,0BAA0B;CAC9B;;CAEA;;GAEE;;CAEF;KACI,sBAAsB;KACtB,gBAAgB;KAChB,kBAAkB;CACtB;;CAEA;KACI,UAAU;CACd;;CAEA;IACG,kBAAkB;CACrB","sourcesContent":["/*! sanitize.css v4.1.0 | CC0 License | github.com/jonathantneal/sanitize.css */\n\n/* Display definitions\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n * 2. Add the correct display in IE.\n */\n\n article,\n aside,\n details, /* 1 */\n figcaption,\n figure,\n footer,\n header,\n main, /* 2 */\n menu,\n nav,\n section,\n summary { /* 1 */\n     display: block;\n }\n \n /**\n  * Add the correct display in IE 9-.\n  */\n \n audio,\n canvas,\n progress,\n video {\n     display: inline-block;\n }\n \n /**\n  * Add the correct display in iOS 4-7.\n  */\n \n audio:not([controls]) {\n     display: none;\n     height: 0;\n }\n \n /**\n  * Add the correct display in IE 10-.\n  * 1. Add the correct display in IE.\n  */\n \n template, /* 1 */\n [hidden] {\n     display: none;\n }\n \n /* Elements of HTML (https://www.w3.org/TR/html5/semantics.html)\n    ========================================================================== */\n \n /**\n  * 1. Remove repeating backgrounds in all browsers (opinionated).\n  * 2. Add box sizing inheritence in all browsers (opinionated).\n  */\n \n *,\n ::before,\n ::after {\n     background-repeat: no-repeat; /* 1 */\n     box-sizing: inherit; /* 2 */\n }\n \n /**\n  * 1. Add text decoration inheritance in all browsers (opinionated).\n  * 2. Add vertical alignment inheritence in all browsers (opinionated).\n  */\n \n ::before,\n ::after {\n     text-decoration: inherit; /* 1 */\n     vertical-align: inherit; /* 2 */\n }\n \n /**\n  * 1. Add border box sizing in all browsers (opinionated).\n  * 2. Add the default cursor in all browsers (opinionated).\n  * 3. Add a flattened line height in all browsers (opinionated).\n  * 4. Prevent font size adjustments after orientation changes in IE and iOS.\n  */\n \n html {\n     box-sizing: border-box; /* 1 */\n     cursor: default; /* 2 */\n     font-family: sans-serif; /* 3 */\n     line-height: 1.5; /* 3 */\n     -ms-text-size-adjust: 100%; /* 4 */\n     -webkit-text-size-adjust: 100%; /* 5 */\n }\n \n /* Sections (https://www.w3.org/TR/html5/sections.html)\n    ========================================================================== */\n \n /**\n  * Remove the margin in all browsers (opinionated).\n  */\n \n body {\n     margin: 0;\n }\n \n /**\n  * Correct the font sizes and margins on `h1` elements within\n  * `section` and `article` contexts in Chrome, Firefox, and Safari.\n  */\n \n h1 {\n     font-size: 2em;\n     margin: .67em 0;\n }\n \n /* Grouping content (https://www.w3.org/TR/html5/grouping-content.html)\n    ========================================================================== */\n \n /**\n  * 1. Correct font sizing inheritance and scaling in all browsers.\n  * 2. Correct the odd `em` font sizing in all browsers.\n  */\n \n code,\n kbd,\n pre,\n samp {\n     font-family: monospace, monospace; /* 1 */\n     font-size: 1em; /* 2 */\n }\n \n /**\n  * 1. Correct the height in Firefox.\n  * 2. Add visible overflow in Edge and IE.\n  */\n \n hr {\n     height: 0; /* 1 */\n     overflow: visible; /* 2 */\n }\n \n /**\n  * Remove the list style on navigation lists in all browsers (opinionated).\n  */\n \n nav ol,\n nav ul {\n     list-style: none;\n }\n \n /* Text-level semantics\n    ========================================================================== */\n \n /**\n  * 1. Add a bordered underline effect in all browsers.\n  * 2. Remove text decoration in Firefox 40+.\n  */\n \n abbr[title] {\n     border-bottom: 1px dotted; /* 1 */\n     text-decoration: none; /* 2 */\n }\n \n /**\n  * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n  */\n \n b,\n strong {\n     font-weight: inherit;\n }\n \n /**\n  * Add the correct font weight in Chrome, Edge, and Safari.\n  */\n \n b,\n strong {\n     font-weight: bolder;\n }\n \n /**\n  * Add the correct font style in Android 4.3-.\n  */\n \n dfn {\n     font-style: italic;\n }\n \n /**\n  * Add the correct colors in IE 9-.\n  */\n \n mark {\n     background-color: #ffff00;\n     color: #000000;\n }\n \n /**\n  * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n  */\n \n progress {\n     vertical-align: baseline;\n }\n \n /**\n  * Correct the font size in all browsers.\n  */\n \n small {\n     font-size: 83.3333%;\n }\n \n /**\n  * Change the positioning on superscript and subscript elements\n  * in all browsers (opinionated).\n  * 1. Correct the font size in all browsers.\n  */\n \n sub,\n sup {\n     font-size: 83.3333%; /* 1 */\n     line-height: 0;\n     position: relative;\n     vertical-align: baseline;\n }\n \n sub {\n     bottom: -.25em;\n }\n \n sup {\n     top: -.5em;\n }\n \n /*\n  * Remove the text shadow on text selections (opinionated).\n  * 1. Restore the coloring undone by defining the text shadow (opinionated).\n  */\n \n ::-moz-selection {\n     background-color: #b3d4fc; /* 1 */\n     color: #000000; /* 1 */\n     text-shadow: none;\n }\n \n ::selection {\n     background-color: #b3d4fc; /* 1 */\n     color: #000000; /* 1 */\n     text-shadow: none;\n }\n \n /* Embedded content (https://www.w3.org/TR/html5/embedded-content-0.html)\n    ========================================================================== */\n \n /*\n  * Change the alignment on media elements in all browers (opinionated).\n  */\n \n audio,\n canvas,\n iframe,\n img,\n svg:not([class^=\"Mui\"]),\n video {\n     vertical-align: middle;\n }\n \n /**\n  * Remove the border on images inside links in IE 10-.\n  */\n \n img {\n     border-style: none;\n }\n \n /**\n  * Change the fill color to match the text color in all browsers (opinionated).\n  */\n \n svg {\n     fill: currentColor;\n }\n \n /**\n  * Hide the overflow in IE.\n  */\n \n svg:not(:root) {\n     overflow: hidden;\n }\n \n /* Links (https://www.w3.org/TR/html5/links.html#links)\n    ========================================================================== */\n \n /**\n  * 1. Remove the gray background on active links in IE 10.\n  * 2. Remove the gaps in underlines in iOS 8+ and Safari 8+.\n  */\n \n a {\n     background-color: transparent; /* 1 */\n     -webkit-text-decoration-skip: objects; /* 2 */\n }\n \n /**\n  * Remove the outline when hovering in all browsers (opinionated).\n  */\n \n a:hover {\n     outline-width: 0;\n }\n \n /* Tabular data (https://www.w3.org/TR/html5/tabular-data.html)\n    ========================================================================== */\n \n /*\n  * Remove border spacing in all browsers (opinionated).\n  */\n \n table {\n     border-collapse: collapse;\n     border-spacing: 0;\n }\n \n /* transform-style:  (https://www.w3.org/TR/html5/forms.html)\n    ========================================================================== */\n \n /**\n  * 1. Remove the default styling in all browsers (opinionated).\n  * 3. Remove the margin in Firefox and Safari.\n  */\n \n button,\n input,\n select,\n textarea {\n     background-color: transparent; /* 1 */\n     border-style: none; /* 1 */\n     color: inherit; /* 1 */\n     font-size: 1em; /* 1 */\n     margin: 0; /* 3 */\n }\n \n /**\n  * Correct the overflow in IE.\n  * 1. Correct the overflow in Edge.\n  */\n \n button,\n input { /* 1 */\n     overflow: visible;\n }\n \n /**\n  * Remove the inheritance in Edge, Firefox, and IE.\n  * 1. Remove the inheritance in Firefox.\n  */\n \n button,\n select { /* 1 */\n     text-transform: none;\n }\n \n /**\n  * 1. Prevent the WebKit bug where (2) destroys native `audio` and `video`\n  *    controls in Android 4.\n  * 2. Correct the inability to style clickable types in iOS and Safari.\n  */\n \n button,\n html [type=\"button\"], /* 1 */\n [type=\"reset\"],\n [type=\"submit\"] {\n     -webkit-appearance: button; /* 2 */\n }\n \n /**\n  * Remove the inner border and padding in Firefox.\n  */\n \n ::-moz-focus-inner {\n     border-style: none;\n     padding: 0;\n }\n \n /**\n  * Correct the focus styles unset by the previous rule.\n  */\n \n :-moz-focusring {\n     outline: 1px dotted ButtonText;\n }\n \n /**\n  * Correct the border, margin, and padding in all browsers.\n  */\n \n fieldset {\n     border: 1px solid #c0c0c0;\n     margin: 0 2px;\n     padding: .35em .625em .75em;\n }\n \n /**\n  * 1. Correct the text wrapping in Edge and IE.\n  * 2. Remove the padding so developers are not caught out when they zero out\n  *    `fieldset` elements in all browsers.\n  */\n \n legend {\n     display: table; /* 1 */\n     max-width: 100%; /* 1 */\n     padding: 0; /* 2 */\n     white-space: normal; /* 1 */\n }\n \n /**\n  * 1. Remove the vertical scrollbar in IE.\n  * 2. Change the resize direction on textareas in all browsers (opinionated).\n  */\n \n textarea {\n     overflow: auto; /* 1 */\n     resize: vertical; /* 2 */\n }\n \n /**\n  * Remove the padding in IE 10-.\n  */\n \n [type=\"checkbox\"],\n [type=\"radio\"] {\n     padding: 0;\n }\n \n /**\n  * Correct the cursor style on increment and decrement buttons in Chrome.\n  */\n \n ::-webkit-inner-spin-button,\n ::-webkit-outer-spin-button {\n     height: auto;\n }\n \n /**\n  * 1. Correct the odd appearance in Chrome and Safari.\n  * 2. Correct the outline style in Safari.\n  */\n \n [type=\"search\"] {\n     -webkit-appearance: textfield; /* 1 */\n     outline-offset: -2px; /* 2 */\n }\n \n /**\n  * Remove the inner padding and cancel buttons in Chrome and Safari for OS X.\n  */\n \n ::-webkit-search-cancel-button,\n ::-webkit-search-decoration {\n     -webkit-appearance: none;\n }\n \n /**\n  * Correct the text style on placeholders in Chrome, Edge, and Safari.\n  */\n \n ::-webkit-input-placeholder {\n     color: inherit;\n     opacity: .54;\n }\n \n /**\n  * 1. Correct the inability to style clickable types in iOS and Safari.\n  * 2. Change font properties to `inherit` in Safari.\n  */\n \n ::-webkit-file-upload-button {\n     -webkit-appearance: button; /* 1 */\n     font: inherit; /* 2 */\n }\n \n /* WAI-ARIA (https://www.w3.org/TR/html5/dom.html#wai-aria)\n    ========================================================================== */\n \n /**\n  * Change the cursor on busy elements (opinionated).\n  */\n \n [aria-busy=\"true\"] {\n     cursor: progress;\n }\n \n /*\n  * Change the cursor on control elements (opinionated).\n  */\n \n [aria-controls] {\n     cursor: pointer;\n }\n \n /*\n  * Change the cursor on disabled, not-editable, or otherwise\n  * inoperable elements (opinionated).\n  */\n \n [aria-disabled] {\n     cursor: default;\n }\n \n /* User interaction (https://www.w3.org/TR/html5/editing.html)\n    ========================================================================== */\n \n /*\n  * Remove the tapping delay on clickable elements (opinionated).\n  * 1. Remove the tapping delay in IE 10.\n  */\n \n a,\n area,\n button,\n input,\n label,\n select,\n textarea,\n [tabindex] {\n     -ms-touch-action: manipulation; /* 1 */\n     touch-action: manipulation;\n }\n \n /*\n  * Change the display on visually hidden accessible elements (opinionated).\n  */\n \n [hidden][aria-hidden=\"false\"] {\n     clip: rect(0, 0, 0, 0);\n     display: inherit;\n     position: absolute;\n }\n \n [hidden][aria-hidden=\"false\"]:focus {\n     clip: auto;\n }\n \n p {\n    font-family: unset;\n }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
